module.exports = __webpack_public_path__ + "static/media/insurance-accepted.3bf89532.svg";